export default __webpack_public_path__ + "static/default-demolition-clp-647c06b398a7a285201a4732ebd98034.png";